// Datos completos de las áreas de práctica
// Extraídos del brochure oficial de Ospino & Piñeres Abogados & Asociados S.A.S.

import {
    Banknote,
    Scale,
    Gavel,
    Building2,
    FileSignature,
    Receipt,
    Briefcase,
    Users,
    Ship,
    Landmark,
    ShieldAlert,
    BookOpen,
    Lightbulb,
  } from "lucide-react";
  
  export const SERVICES = [
    {
      slug: "administracion-cobro-cartera",
      icon: Banknote,
      title: "Administración y Cobro de Cartera",
      short:
        "Gestión integral y recuperación de cartera para mejorar la liquidez y el flujo financiero de su empresa.",
      description:
        "Servicio integral de gestión y recuperación de cartera, orientado a mejorar la liquidez y el flujo financiero de su empresa. Combinamos experiencia jurídica, capacidad operativa y enfoque estratégico para asegurar resultados medibles.",
      bullets: [
        "Diagnóstico y clasificación de cartera",
        "Gestión preventiva, persuasiva y judicial",
        "Negociación directa con deudores",
        "Ejecución de procesos de cobro",
        "Informes periódicos de avance y recuperación",
      ],
    },
    {
      slug: "derecho-constitucional",
      icon: Scale,
      title: "Derecho y Acciones Constitucionales",
      short:
        "Defensa de derechos fundamentales y mecanismos constitucionales con enfoque preventivo y correctivo.",
      description:
        "Asesoría y representación especializada en el ejercicio de mecanismos constitucionales de protección, control y defensa jurídica, orientados a salvaguardar derechos fundamentales, garantizar el cumplimiento normativo y fortalecer la seguridad institucional de personas, empresas y entidades públicas.",
      bullets: [
        "Análisis técnico y formulación de estrategias jurídicas",
        "Defensa activa ante autoridades judiciales y administrativas",
        "Litigio estratégico y defensa de políticas públicas",
        "Protección de derechos colectivos",
        "Asesoría en escenarios de control constitucional",
      ],
    },
    {
      slug: "derecho-procesal",
      icon: Gavel,
      title: "Derecho Procesal: Litigios y Actuaciones",
      short:
        "Litigio estratégico y mecanismos de resolución de conflictos en sede judicial y administrativa.",
      description:
        "Equipo especializado en litigio estratégico, derecho procesal y mecanismos de resolución de conflictos, orientado a la defensa técnica y la gestión eficiente de procesos judiciales y administrativos.",
      bullets: [
        "Representación procesal en todas las etapas del litigio",
        "Intervención en trámites administrativos con impacto jurídico",
        "Mecanismos alternativos de solución de conflictos",
        "Defensa institucional ante organismos de supervisión y vigilancia",
      ],
    },
    {
      slug: "derecho-inmobiliario",
      icon: Building2,
      title: "Derecho Inmobiliario",
      short:
        "Asesoría jurídica integral en operaciones, contratos y conflictos sobre bienes inmuebles.",
      description:
        "Asesoría jurídica integral en operaciones y conflictos relacionados con bienes inmuebles, orientada a garantizar seguridad jurídica, eficiencia contractual y cumplimiento normativo en el sector inmobiliario.",
      bullets: [
        "Negociación, estructuración y formalización de contratos (compraventa, arrendamiento, fiducia, promesas)",
        "Estudios de títulos, saneamiento jurídico y gestión de riesgos",
        "Trámites notariales, registrales y administrativos",
        "Litigios de propiedad, posesión, servidumbres y restitución",
        "Asesoría a constructoras, inversionistas y copropiedades",
      ],
    },
    {
      slug: "derecho-contractual",
      icon: FileSignature,
      title: "Derecho Contractual Público y Privado",
      short:
        "Estructuración, negociación y ejecución de contratos civiles, mercantiles y estatales.",
      description:
        "Asesoría jurídica especializada en la estructuración, negociación y ejecución de contratos civiles, mercantiles y estatales. Acompañamiento integral en la definición de términos contractuales, gestión de riesgos, cumplimiento normativo y resolución de controversias.",
      bullets: [
        "Diseño y revisión de contratos civiles y mercantiles",
        "Contratación estatal y pliegos",
        "Gestión de riesgos contractuales",
        "Resolución de controversias",
        "Auditorías contractuales preventivas",
      ],
    },
    {
      slug: "derecho-tributario",
      icon: Receipt,
      title: "Derecho Tributario Distrital, Departamental y Nacional",
      short:
        "Planeación, cumplimiento y defensa fiscal en los distintos niveles del régimen tributario.",
      description:
        "Asesoría jurídica y contable especializada en materia tributaria, de orden nacional, departamental y distrital/municipal. Acompañamos a personas naturales y jurídicas en el ejercicio efectivo de sus derechos fiscales, la protección de sus intereses patrimoniales y el cumplimiento normativo.",
      bullets: [
        "Planeación tributaria estratégica",
        "Defensa fiscal ante DIAN y autoridades territoriales",
        "Cumplimiento normativo y obligaciones formales",
        "Análisis normativo y conceptos jurídicos",
        "Gestión de devoluciones y compensaciones",
      ],
    },
    {
      slug: "derecho-corporativo",
      icon: Briefcase,
      title: "Derecho Empresarial y Corporativo",
      short:
        "Acompañamiento legal y contable integral en la gestión empresarial y corporativa.",
      description:
        "Asesorías y acompañamiento legal y contable en todos los procesos concernientes a la gestión empresarial y corporativa vinculados a procesos de calidad industrial y organizacional.",
      bullets: [
        "Constitución, reorganización y reforma de sociedades",
        "Estructuración, negociación e implementación de proyectos",
        "Gobierno corporativo y secretarías generales",
        "Análisis de riesgos en operaciones y transacciones",
        "Due diligence y M&A",
      ],
    },
    {
      slug: "derecho-laboral",
      icon: Users,
      title: "Derecho Laboral y de la Seguridad Social",
      short:
        "Gestión laboral con enfoque preventivo, normativo y estratégico para empresas y entidades.",
      description:
        "Asesoría jurídica especializada en la gestión laboral de empresas y entidades públicas, con enfoque preventivo, normativo y estratégico.",
      bullets: [
        "Reglamentos internos, políticas laborales y esquemas de contratación",
        "Compensación, planes de retiro y procesos disciplinarios",
        "Liquidación de acreencias laborales",
        "Conciliaciones ante autoridades competentes",
        "Programas de formación en temas laborales",
      ],
    },
    {
      slug: "derecho-aduanero",
      icon: Ship,
      title: "Derecho Aduanero y Comercio Exterior",
      short:
        "Operaciones aduaneras y comercio internacional con dominio normativo nacional e internacional.",
      description:
        "Asesoría jurídica especializada en operaciones aduaneras y de comercio internacional, con dominio normativo a nivel nacional e internacional.",
      bullets: [
        "Régimen jurídico aduanero y procedimientos especiales",
        "Trámites y relaciones entre sujetos aduaneros",
        "Operaciones de intercambio internacional de bienes y servicios",
        "Defensa en procesos sancionatorios aduaneros",
        "Clasificación arancelaria y origen",
      ],
    },
    {
      slug: "derecho-financiero",
      icon: Landmark,
      title: "Derecho Financiero, Bancario y del Sector Solidario",
      short:
        "Cumplimiento, estructuración y defensa para entidades financieras, cooperativas y fondos.",
      description:
        "Asesoría a entidades financieras, cooperativas, fondos de empleados y organizaciones del sector solidario en el cumplimiento normativo, la estructuración de operaciones y la gestión de riesgos jurídicos.",
      bullets: [
        "Procesos de supervisión y control interno",
        "Gobierno corporativo del sector financiero y solidario",
        "Contratación especializada",
        "Defensa institucional ante autoridades administrativas y jurisdiccionales",
        "SARLAFT y prevención de riesgos",
      ],
    },
    {
      slug: "derecho-penal",
      icon: ShieldAlert,
      title: "Derecho Penal",
      short:
        "Defensa técnica integral, protegiendo derechos y garantías constitucionales de nuestros clientes.",
      description:
        "Intervención en actuaciones penales con enfoque jurídico integral, protegiendo los derechos de nuestros clientes y asegurando el cumplimiento de garantías constitucionales.",
      bullets: [
        "Defensa en investigación, juzgamiento y ejecución de penas",
        "Delitos comunes y de alta complejidad jurídica",
        "Asuntos penales empresariales e institucionales",
        "Representación de víctimas",
        "Estrategias de cumplimiento penal",
      ],
    },
    {
      slug: "derecho-civil",
      icon: BookOpen,
      title: "Derecho Civil",
      short:
        "Régimen civil colombiano: asuntos patrimoniales, personales y contractuales.",
      description:
        "Asesoría jurídica especializada en el régimen civil colombiano, interviniendo en la estructuración, análisis y resolución de asuntos patrimoniales, personales y contractuales.",
      bullets: [
        "Controversias sobre propiedad y posesión",
        "Sucesiones y procesos de familia",
        "Contratos civiles y responsabilidad civil",
        "Asuntos personales y patrimoniales",
        "Toma de decisiones jurídicas con impacto privado",
      ],
    },
    {
      slug: "propiedad-intelectual",
      icon: Lightbulb,
      title: "Propiedad Intelectual",
      short:
        "Protección del valor jurídico de creaciones, signos distintivos y activos intangibles.",
      description:
        "Protegemos el valor jurídico de las creaciones, signos distintivos y activos intangibles de nuestros clientes, con estrategia integral nacional e internacional.",
      bullets: [
        "Registro y defensa de marcas y nombres comerciales",
        "Derechos de autor y obras digitales",
        "Patentes y diseños industriales",
        "Secretos empresariales y know-how",
        "Estrategias de protección internacional",
      ],
    },
  ];
  
  export const getServiceBySlug = (slug) =>
    SERVICES.find((s) => s.slug === slug);
  
  // Información de contacto (placeholders - actualizar cuando el cliente entregue datos oficiales)
  export const FIRM = {
    name: "Ospino & Piñeres Abogados & Asociados S.A.S.",
    shortName: "Ospino & Piñeres",
    address: {
      line1: "Edificio Comodoro – Plazoleta Benkos Biohó",
      line2: "Oficinas 601 y 602",
      city: "Cartagena de Indias, Colombia",
    },
    phone: "+57 (5) 000 0000",
    whatsapp: "+573000000000", // formato internacional sin signos para wa.me
    email: "contacto@ospinoypineres.com",
    hours: "Lun – Vie · 8:00 a.m. – 6:00 p.m.",
    // Coordenadas Plazoleta Benkos Biohó - Cartagena
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3923.9562545533618!2d-75.54555079999999!3d10.425046199999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ef62f9e815825bf%3A0x618141dc103bbccd!2sEdificio%20Comodoro!5e0!3m2!1ses!2sco!4v1777776315386!5m2!1ses!2sco",
  };
  
  export const whatsappLink = (
    message = "Hola, deseo agendar una asesoría con Ospino & Piñeres Abogados."
  ) =>
    `https://wa.me/${FIRM.whatsapp.replace(
      /D/g,
      ""
    )}?text=${encodeURIComponent(message)}`;
  